import { render, staticRenderFns } from "./chatComponents.vue?vue&type=template&id=1160e5c4&scoped=true&"
import script from "./chatComponents.vue?vue&type=script&lang=js&"
export * from "./chatComponents.vue?vue&type=script&lang=js&"
import style0 from "./chatComponents.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1160e5c4",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/kinglinux/.baobaobot/teams/白/workspace_3GTAPP/projects/ita.GroupTravel.Website/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1160e5c4')) {
      api.createRecord('1160e5c4', component.options)
    } else {
      api.reload('1160e5c4', component.options)
    }
    module.hot.accept("./chatComponents.vue?vue&type=template&id=1160e5c4&scoped=true&", function () {
      api.rerender('1160e5c4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/ita/components/chatComponents.vue"
export default component.exports